import { ref } from "vue";
import { defineStore } from "pinia";

export const useKycStore = defineStore("kyc", () => {
  const isKYCWidgetOpen = ref(false);
  const isKYCButtonTempHidden = ref(false);

  const getIsKYCButtonTempHidden = () => {
    return isKYCButtonTempHidden.value;
  };

  const setIsKYCButtonTempHidden = (data) => {
    isKYCButtonTempHidden.value = data;
  };

  const getIsKYCWidgetOpen = () => {
    return isKYCWidgetOpen.value;
  };

  const setIsKYCWidgetOpen = (data) => {
    isKYCWidgetOpen.value = data;
  };

  const isKYCModalOpen = ref(false);

  const getIsKYCModalOpen = () => {
    return isKYCModalOpen.value;
  };

  const setIsKYCModalOpen = (data) => {
    isKYCModalOpen.value = data;
  };

  const isKYCShortModalOpen = ref(false);

  const getIsKYCShortModalOpen = () => {
    return isKYCShortModalOpen.value;
  };

  const setIsKYCShortModalOpen = (data) => {
    isKYCShortModalOpen.value = data;
  };

  const isKYCPendingModalOpen = ref(false);

  const getIsKYCPendingModalOpen = () => {
    return isKYCPendingModalOpen.value;
  };

  const setIsKYCPendingModalOpen = (data) => {
    isKYCPendingModalOpen.value = data;
  };

  return {
    getIsKYCWidgetOpen,
    getIsKYCModalOpen,
    getIsKYCShortModalOpen,
    getIsKYCPendingModalOpen,
    setIsKYCWidgetOpen,
    setIsKYCModalOpen,
    setIsKYCShortModalOpen,
    setIsKYCPendingModalOpen,
    getIsKYCButtonTempHidden,
    setIsKYCButtonTempHidden,
  };
});
